import { defineStore } from 'pinia'
import { ref } from 'vue'
import { NotificationItemType, NotificationTypeEnum } from '@notifications/definitions/models'

export const useNotificationsStore = defineStore('useNotificationsStore', () => {
  const notifications = ref<Record<string, NotificationItemType>>({})

  const addNotification = (key: string, type: NotificationTypeEnum, text: string) => {
    const existing = notifications.value[key]
    if (existing) {
      existing.counter++
    } else {
      notifications.value[key] = {
        key,
        counter: 1,
        type,
        text
      }
    }

    // Автоудаление через 10 секунд
    setTimeout(() => {
      removeNotification(key)
    }, 10000)
  }

  const removeNotification = (key: string) => {
    const existing = notifications.value[key]
    if (!existing) return

    if (existing.counter > 1) {
      existing.counter--
    } else {
      delete notifications.value[key]
    }
  }

  return {
    notifications,
    addNotification,
    removeNotification
  }
})
